import { ROUTE, ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import loadSectionAction from 'modules/section/actions/load'

/**
 * Loads the current user's notifications.
 * @param  {Object} [options={}]
 * @returns {Function}
 */
function loadNotificationsAction (options = {}) {
  return loadSectionAction(ROUTE[ROUTE_PATH.NOTIFICATIONS], {}, options)
}

export {
  loadNotificationsAction
}
